import { render, staticRenderFns } from "./activity-block.vue?vue&type=template&id=638c8b8e&scoped=true"
import script from "./activity-block.vue?vue&type=script&lang=js"
export * from "./activity-block.vue?vue&type=script&lang=js"
import style0 from "./activity-block.vue?vue&type=style&index=0&id=638c8b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c8b8e",
  null
  
)

export default component.exports